import { render, staticRenderFns } from "./estatistica_cadastro.vue?vue&type=template&id=2feb939f&"
import script from "./estatistica_cadastro.vue?vue&type=script&lang=js&"
export * from "./estatistica_cadastro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports